<div class="row button-row">
  <div class="col-4">
    <button mat-raised-button class="add-btn mat-elevation-z2" (click)="onAddFundClick()"><i class="material-icons" style="font-size: 16px">add</i><i class="material-icons" style="font-size: 16px; margin-right: 3px">account_balance</i>Fund</button>
    <button mat-raised-button class="add-btn mat-elevation-z2" (click)="onAddCertificatedClick()"><i class="material-icons" style="font-size: 16px">add</i><i class="material-icons" style="font-size: 16px; margin-right: 3px">account_balance</i>Certificated</button>
  </div>
</div>
